import { useState, useEffect, useRef, useContext } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import HTMLFlipBook from "react-pageflip";
import html2canvas from "html2canvas";
import { Toaster, toast } from "react-hot-toast";
import jwt_decode from "jwt-decode";
// Context
import { ReadingTimeContext } from "../../../Context/readingTimeContext";
import { AuthContext } from "../../../Context/AuthContext";
// Components
import PageCover from "../../Common/Library/PageCover/PageCover";
import Pages from "../../Common/Library/Pages/Pages";
import Comment from "../../Common/Comment/Comment";
// import DownloadCard from "../../Common/downloadCard/DownloadCard";
// Images
import logoImg from "../../../Assets/Images/logo.png";
import closeImg from "../../../Assets/Icons/close.png";
// Styles
import Styles from "./Styles/Library.module.css";
import convertNumbersToPersian from "../../../Utils/convertNumbersToPersian";
import {
  getSingleBook,
  getSingleBookNotBuyed,
} from "../../../Services/getData";
import RemainingTime from "../../Common/readingTime/RemainingTime";
import ReadingTime from "../../Common/readingTime/ReadingTime";
import {
  createComment,
  setLastPageUserReaded,
  setReadingTime,
} from "../../../Services/usersService";
import { BookPageImagesContext } from "../../../Context/bookPagesContext";

const Library = () => {
  const { isLoggedIn } = useContext(AuthContext);
  const { removeImages } = useContext(BookPageImagesContext);
  const history = useHistory();
  const { bookId } = useParams();
  const [showBookDescription, setShowBookDescription] = useState(true);
  // const [bookTexts, setBookText] = useState(
  //   " دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد. سلام منم هستم اینجاو با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده تنبیس سلام منم هستم اینجا"
  // );

  // text length 762

  // const [showSelectText, setShowSelectText] = useState("");
  // const [selectedText, setSelectedText] = useState("");
  const [flipPageWidth, setFlipPageWidth] = useState(500);
  const [flipPageHeight, setFlipPageHeight] = useState(600);
  const pageFlipRef = useRef(null);
  const [showComments, setShowComments] = useState(false);
  const [bookPages, setBookPages] = useState([]);
  const [book, setBook] = useState();
  const [purchased, setPurchased] = useState(false);
  // const textDownloadRef = useRef();

  const [percentage, setPercentage] = useState(0);
  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [startPage, setStartPage] = useState(0);

  const token = localStorage.getItem("token");
  const [decodedToken, setDecodedToken] = useState();

  const [commentSendTimer, setCommentSendTimer] = useState(0);
  const [commentText, setCommentText] = useState("");
  const [commentSended, setCommentSended] = useState(false);

  const [haveEmptyPage, setHaveEmptyPage] = useState(false);

  // useEffect(() => {
  //   if (!isLoggedIn) {
  //     history.replace("/");
  //     toast.error("برای مطالعه کتاب ابتدا وارد حساب کاربر خود شوید");
  //   }
  // }, [isLoggedIn, history]);

  useEffect(() => {
    removeImages();
  }, []);

  // محدودیت ارسال کامنت
  useEffect(() => {
    if (commentSendTimer !== 0) {
      const sendCommentTimerInterval = setInterval(() => {
        setCommentSendTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(sendCommentTimerInterval);
    }
  }, [commentSendTimer]);

  useEffect(() => {
    if (token) {
      setDecodedToken(jwt_decode(token));
    }
  }, [token]);
  // create view
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       await createView({ type: "book", id: bookId });
  //     } catch (ex) {
  //       toast.error(ex.response.data.message);
  //     }
  //   };
  //   // if(isLoggedIn&&book.)
  //   fetchData();
  // }, []);

  // ارسال زمان مطالعه هنگام خروج
  const { timer, addTime, resetTimer } = useContext(ReadingTimeContext);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      addTime();
    }, 1000);
    return () => clearInterval(timerInterval);
  }, [timer, addTime]);

  useEffect(() => {
    const fetchData = async () => {
      const data = { kind: "book", id: book._id, readingTime: timer };
      try {
        await setReadingTime(data);
        resetTimer();
      } catch (ex) {
        console.log(ex.response.data.message);
      }
    };
    if (timer / 60 === 1) {
      fetchData();
    }
  }, [timer, book, resetTimer]);

  // دریافت اطلاعات
  useEffect(() => {
    const api = async () => {
      try {
        let data;
        if (isLoggedIn) {
          const result = await getSingleBook(bookId);
          data = result.data;
        } else {
          const result = await getSingleBookNotBuyed(bookId);
          data = result.data;
          toast.error("جهت مطالعه خلاصه کتاب لطفا وارد حساب کاربری خود شوید");
        }
        const newBokpages = data.bookPagesAddress;
        // if (data.bookPagesAddress.length % 2 === 1) {
        //   newBokpages.push([{ kind: "empty" }]);
        // }
        if (data.bookPagesAddress.length % 2 === 1) {
          setHaveEmptyPage(true);
        }
        // setBookPages(data.bookPagesAddress);
        setBookPages(newBokpages);
        setPurchased(data.purchase);
        setBook(data.book);
        console.log(data.book);

        setStartPage(
          data.startPage === data.bookPagesAddress.length
            ? data.bookPagesAddress.length - 1
            : data.startPage
        );
        setPercentage(
          data.startPage === data.bookPagesAddress.length
            ? Math.round(
                ((data.startPage - 1) * 100) / data.bookPagesAddress.length
              )
            : Math.round((data.startPage * 100) / data.bookPagesAddress.length)
        );
        setCurrentPage(data.bookPagesAddress.length - data.startPage);
        setTotalPages(data.bookPagesAddress.length + 1);
      } catch (ex) {
        toast.error(ex.response.data.message);
        // return history.push("/");
      }
    };
    // if (token) {
    api();
    // }
    // if (isLoggedIn && token) {
    //   api();
    // }
  }, [bookId, history, commentSended, isLoggedIn, token]);

  //* book size handler
  useEffect(() => {
    if (window.innerWidth < 400) {
      setFlipPageWidth(350);
      setFlipPageHeight(450);
    } else if (window.innerWidth < 500) {
      setFlipPageWidth(400);
      setFlipPageHeight(500);
    }
  }, []);
  //* copy text handler
  // document.addEventListener("copy", function (event) {
  //   const customText = "مرجع : سایت هرمه";

  //   const copiedText = window.getSelection().toString() + " | " + customText;

  //   event.clipboardData.setData("text/plain", copiedText);

  //   event.preventDefault();
  // });

  // const handleCopyText = () => {
  //   const customText = "مرجع : سایت هرمه";
  //   const copiedText = selectedText + " | " + customText;
  //   navigator.clipboard
  //     .writeText(copiedText)
  //     .then(() => {
  //       toast.success("متن با موفقیت کپی شد");
  //     })
  //     .catch((error) => {
  //       console.error("خطا در کپی متن:", error);
  //     });
  // };

  //* flip book with keyboard
  const flipPageForward = async () => {
    if (pageFlipRef.current) {
      pageFlipRef.current.pageFlip().flipNext();
    }
  };

  const flipPageBackward = () => {
    if (pageFlipRef.current) {
      pageFlipRef.current.pageFlip().flipPrev();
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.keyCode === 37) {
        // دکمه چپ کیبورد
        flipPageBackward();
      } else if (event.keyCode === 39) {
        // دکمه راست کیبورد
        flipPageForward();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  // const handleSelectText = (text) => {
  //   setShowSelectText(text);
  // };
  // const handleClickText = () => {
  //   setSelectedText(window.getSelection().toString());
  // };

  //* download text handler
  // const handleDownloadSelectedText = () => {
  //   html2canvas(textDownloadRef.current).then((canvas) => {
  //     const image = canvas.toDataURL("image/png");
  //     const link = document.createElement("a");
  //     link.href = image;
  //     link.download = "card.png";
  //     link.click();
  //   });
  // };

  //* download page handler
  const downloadImage = (downloadRef) => {
    html2canvas(downloadRef.current).then((canvas) => {
      const image = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = image;
      link.download = "card.png";
      link.click();
    });
  };

  //* close select text page handler
  // const handleCloseSelectText = () => {
  //   setShowSelectText("");
  // };

  //* handle highlight
  // const handleHighlightText = () => {
  //   if (selectedText) {
  //     if (window.getSelection().focusNode.parentElement.nodeName !== "SPAN") {
  //       const coloredContent = bookTexts.replace(
  //         selectedText,
  //         `<span>${selectedText}</span>`
  //       );
  //       setBookText(coloredContent);
  //       setShowSelectText(false);
  //     } else {
  //       toast.error("متن هایلایت شده را نمیتوانید هایلایت کنید!");
  //     }
  //   }
  // };

  // const deleteHighlight = () => {
  //   if (selectedText) {
  //     if (window.getSelection().focusNode.parentElement.nodeName === "SPAN") {
  //       const coloredContent = bookTexts.replace(
  //         window.getSelection().focusNode.parentElement.outerHTML,
  //         window.getSelection().focusNode.parentElement.innerHTML
  //       );
  //       setBookText(coloredContent);
  //       setShowSelectText(coloredContent);
  //     } else {
  //       toast.error(
  //         "برای حذف هایلایت میتوانید روی متن هایلایت شده کلیک کنید یا قسمتی از آن را انتخاب کنید"
  //       );
  //     }
  //   }
  // };
  function convertSpecificNumbersToPersian(text) {
    const persianNumbers = {
      0: "۰",
      1: "۱",
      2: "۲",
      3: "۳",
      4: "۴",
      5: "۵",
      6: "۶",
      7: "۷",
      8: "۸",
      9: "۹",
    };

    return text.replace(/[0-9]/g, function (match) {
      return persianNumbers[match];
    });
  }
  // sendComment
  const sendComment = (comment) => {
    if (!isLoggedIn) {
      toast.error("برای نظردهی ابتدا باید وارد حساب کاربری خود شوید");
      return;
    }
    if (comment.length === 0) {
      toast.error("لطفا ابتدا یک متن وارد کنید");
      return;
    }
    if (commentSendTimer === 0) {
      const data = {
        comment,
        userId: decodedToken.user.userId,
        id: book._id,
        kind: "book",
      };
      toast.promise(createComment(data), {
        loading: "درحال ارسال نظر شما . . .",
        success: (res) => {
          setCommentSended((prev) => !prev);
          setCommentText("");
          setCommentSendTimer(60);
          return res.data.message;
        },
        error: (res) => res.data.message,
      });
    } else {
      toast.error(
        `لطفا ${convertSpecificNumbersToPersian(
          commentSendTimer.toString()
        )} ثانیه بعد کامنت بعدی خود را ارسال کنید`
      );
    }
  };

  return (
    <div className={Styles.mainConatiner}>
      <Toaster toastOptions={{ duration: 1500 }} />
      <ReadingTime Styles={Styles} />
      {/* {selectedText.length > 0 && (
        <div
          style={{
            position: "absolute",
            zIndex: -10,
            right: 100000,
            top: -10000,
          }}
        >
          <DownloadCard
            bookName="موفقیت در ۳۰ روز"
            pageNumber={null}
            text={selectedText}
            // writerName={writerName}
            // translatorName={translatorName}
            ref={textDownloadRef}
          />
        </div>
      )} */}

      {showComments && (
        <div className={Styles.commentsContainer}>
          <div
            className={Styles.hideComments}
            onClick={() => setShowComments(false)}
          >
            <img src={closeImg} alt="" />
          </div>
          {book !== undefined && book.comments?.length > 0 ? (
            book.comments.map((item, index) => (
              <Comment
                comment={item.comment}
                username={item.username}
                key={index}
              />
            ))
          ) : (
            <h2 style={{ marginBottom: "25px", color: "#4b495b" }}>
              دیدگاهی وجود ندارد
            </h2>
          )}
          <div className={Styles.sendComment}>
            <div className={Styles.textContainer}>
              <textarea
                placeholder="دیدگاه خود را اینجا بنویسید . . ."
                name="comment"
                id="comment"
                cols="30"
                rows="10"
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
              ></textarea>
              <div className={Styles.title}>
                <h3>دیدگاه</h3>
                <h3>شما</h3>
              </div>
            </div>
            <div className={Styles.sendContainer}>
              <div
                className={Styles.send}
                style={{ textAlign: "center", width: "85.5%" }}
                onClick={() => sendComment(commentText)}
              >
                ثبت
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={Styles.header}>
        <div className={Styles.logoContainer}>
          <div className={Styles.logo}>
            <img src={logoImg} alt="" />
          </div>
        </div>
        <div className={Styles.optionsContainer}>
          <div className={Styles.options}>
            <Link to="/">صفحه اصلی</Link>
            <div className={Styles.separator}></div>
            <h4 onClick={() => setShowComments(true)}>نظر ها</h4>
            <div className={Styles.separator}></div>
            <RemainingTime Styles={Styles} />
          </div>
          <div className={Styles.percent}>
            {purchased ? (
              <h4>
                میزان پیشروی : %{convertNumbersToPersian(percentage.toString())}
              </h4>
            ) : (
              <h4>میزان پیشروی : ۰٪</h4>
            )}
          </div>
        </div>
      </div>
      {/* {showSelectText.length > 0 && (
        <div onMouseUp={handleClickText} className={Styles.selectTextContainer}> */}
      {/* <button onClick={handleCloseSelectText}>بستن</button>
          <p
            onMouseUp={deleteHighlight}
            dangerouslySetInnerHTML={{ __html: showSelectText }}
          ></p> */}
      {/* <div
            className={Styles.options}
            style={selectedText ? { top: "20px" } : {}}
          >
            <img title="کپی" alt="" src={copyImg} onClick={handleCopyText} />
            <img
              title="دانلود"
              alt=""
              src={downloadImg}
              onClick={handleDownloadSelectedText}
            />
            <img
              title="هایلایت"
              alt=""
              src={highlightImg}
              onClick={handleHighlightText}
            />
          </div> */}
      {/* )} */}
      {/* </div>
      )} */}
      <div
        className={Styles.bookShortDescription}
        style={showBookDescription ? {} : { display: "none" }}
      >
        <div className={Styles.right}>
          <div className={Styles.bookShortDescriptionTitleContainer}>
            <h1>چکیده ای از کتاب</h1>
          </div>
          <p>{book?.shortDesc}</p>
          {isLoggedIn && (
            <button onClick={() => setShowBookDescription(false)}>
              خواندن کتاب
            </button>
          )}
        </div>
        <div className={Styles.left}></div>
      </div>
      {book !== undefined &&
        (haveEmptyPage ? (
          <HTMLFlipBook
            showPageCorners={false}
            showCover={true}
            className={Styles.bookContainer}
            width={flipPageWidth}
            height={flipPageHeight}
            ref={pageFlipRef}
            mobileScrollSupport={true}
            startPage={totalPages - startPage + 1}
            onFlip={async (e) => {
              setPercentage(
                e.data === 0
                  ? 100
                  : e.data > totalPages
                  ? 0
                  : Math.round(((bookPages.length - e.data) * 100) / totalPages)
              );
              if (e.data - 1 === totalPages) {
                setShowBookDescription(true);
              }
              setCurrentPage(e.data);
              if (purchased) {
                try {
                  const data = {
                    pageNumber: bookPages.length - e.data,
                    bookId: book._id,
                  };
                  await setLastPageUserReaded(data);
                } catch (ex) {
                  console.log(ex);
                }
              }
            }}
            // renderOnlyPageLengthChange={true}
          >
            <PageCover
              purchase={purchased}
              cover={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${book.backCover}`}
              position="back"
              bookId={bookId}
              price={book.price}
              title={book.title}
            />
            <div className={Styles.emptyPage}></div>
            {bookPages.map((page, index) => (
              // bookPages.length - index === -(index - currentPage) ||
              // bookPages.length - index - 1 === -(index - currentPage - 1) ? (
              <Pages
                currentPage={
                  currentPage === 0
                    ? currentPage
                    : bookPages.length - currentPage
                }
                page={page}
                key={index}
                index={index}
                starterPage={startPage}
                pagesLength={bookPages.length}
                pageNumber={bookPages.length - index}
                downloadImage={downloadImage}
                bookName={book.title}
                isLoggedIn={isLoggedIn}
                // pageImage={pageImage}
                // title="تیتر صفحه اول"
                // text={bookTexts}
                // handleSelectText={handleSelectText}
              />
            ))}

            <PageCover
              cover={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${book.frontCover}`}
              position="front"
            />
          </HTMLFlipBook>
        ) : (
          <HTMLFlipBook
            showPageCorners={false}
            showCover={true}
            className={Styles.bookContainer}
            width={flipPageWidth}
            height={flipPageHeight}
            ref={pageFlipRef}
            mobileScrollSupport={true}
            startPage={totalPages - startPage}
            onFlip={async (e) => {
              setPercentage(
                e.data === 0
                  ? 100
                  : e.data > totalPages
                  ? 0
                  : Math.round(((bookPages.length - e.data) * 100) / totalPages)
              );
              if (e.data === totalPages) {
                setShowBookDescription(true);
              }
              setCurrentPage(e.data);
              if (purchased) {
                try {
                  const data = {
                    pageNumber: bookPages.length - e.data,
                    bookId: book._id,
                  };
                  await setLastPageUserReaded(data);
                } catch (ex) {
                  console.log(ex);
                }
              }
            }}
            // renderOnlyPageLengthChange={true}
          >
            <PageCover
              purchase={purchased}
              cover={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${book.backCover}`}
              position="back"
              bookId={bookId}
              price={book.price}
              title={book.title}
            />

            {bookPages.map((page, index) => (
              // bookPages.length - index === -(index - currentPage) ||
              // bookPages.length - index - 1 === -(index - currentPage - 1) ? (
              <Pages
                currentPage={
                  currentPage === 0
                    ? currentPage
                    : bookPages.length - currentPage
                }
                page={page}
                key={index}
                index={index}
                starterPage={startPage}
                pagesLength={bookPages.length}
                pageNumber={bookPages.length - index}
                downloadImage={downloadImage}
                bookName={book.title}
                isLoggedIn={isLoggedIn}
                // pageImage={pageImage}
                // title="تیتر صفحه اول"
                // text={bookTexts}
                // handleSelectText={handleSelectText}
              />
            ))}

            <PageCover
              cover={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${book.frontCover}`}
              position="front"
            />
          </HTMLFlipBook>
        ))}
    </div>
  );
};

export default Library;
